module.exports = __webpack_public_path__ + "img/dqzt_sel.c795909c.svg";